import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getResourcesByUuid() {
      return getState().resources;
    },
    getPendingResourcesUuids() {
      return getState().pendingUuids;
    },
    getMissingResourcesUuids() {
      return getState().missingUuids;
    },
  };
}

export { createSelector };
